var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 13,
    viewBox: "0 0 11 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.28171 12.4278C6.09882 12.4278 6.76163 11.765 6.76163 10.9472H3.80179C3.80179 11.765 4.46459 12.4278 5.28171 12.4278ZM10.2647 8.96429C9.8177 8.48402 8.98139 7.76153 8.98139 5.39486C8.98139 3.59731 7.72102 2.15833 6.02155 1.8053V1.32318C6.02155 0.914389 5.69026 0.58287 5.28171 0.58287C4.87315 0.58287 4.54186 0.914389 4.54186 1.32318V1.8053C2.8424 2.15833 1.58203 3.59731 1.58203 5.39486C1.58203 7.76153 0.745713 8.48402 0.298753 8.96429C0.159946 9.11351 0.0984076 9.29188 0.0995643 9.46655C0.102109 9.84595 0.399851 10.2069 0.842184 10.2069H9.72123C10.1636 10.2069 10.4615 9.84595 10.4639 9.46655C10.465 9.29188 10.4035 9.11328 10.2647 8.96429Z",
    fill: "#8A8587"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.1362b91a4e9f3af2e1bf55a5b13d3b74.svg";
export { ForwardRef as ReactComponent };